import axios from "axios";
import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";
import { formatGetAddressByPostalCodeErrorMessage } from "api/resources/messages/ErrorMessage";
import {
  AddressResult,
  GetAddressByPostalCodeRequestPayload,
  GetAddressByPostalCodeResponse,
} from "./getAddressByPostalCode.types";
import { GET_ONEMAP_ADDRESS_BY_POSTAL_CODE_URL } from "api/resources/configs/URL";
import { getRequestOptions } from "api/resources/configs/requests";

/**
 * Fetches the Address according to postal code
 *
 * POST
 * Endpoint: /developers.onemap.sg/commonapi
 *
 * @param {string} postalCode
 */
const getAddressByPostalCode = async (
  postalCode: string | null,
): Promise<AddressResult> => {
  try {
    const response = await axios.post<GetAddressByPostalCodeResponse>(
      GET_ONEMAP_ADDRESS_BY_POSTAL_CODE_URL(),
      {
        PostalCode: postalCode ?? "",
      } satisfies GetAddressByPostalCodeRequestPayload,
      getRequestOptions(),
    );
    const responsePayload = parseResponse(
      response,
      GET_ONEMAP_ADDRESS_BY_POSTAL_CODE_URL(),
    );

    if (responsePayload.found) {
      return {
        ...responsePayload.results[0],
        HAS_VALID_ADDRESS: true,
        HAS_ERRORED: false,
      };
    } else {
      return {
        BLK_NO: null,
        ROAD_NAME: null,
        HAS_VALID_ADDRESS: false,
        HAS_ERRORED: false,
      };
    }
  } catch (error) {
    const msg = formatGetAddressByPostalCodeErrorMessage(
      GET_ONEMAP_ADDRESS_BY_POSTAL_CODE_URL(),
    );
    console.error(msg);
    return {
      BLK_NO: null,
      ROAD_NAME: null,
      HAS_VALID_ADDRESS: false,
      HAS_ERRORED: true,
    };
  }
};

export { getAddressByPostalCode };
